import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'other_activities'

export default function OtherActivitiesPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value ? value : undefined

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const sex = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Which activities do you enjoy besides running?',
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.otherActivities.heading')}
      buttons={[
        {
          text: t('pages.onboarding.otherActivities.options.strengthTraining'),
          value: 'strengthTraining',
        },
        {
          text: t('pages.onboarding.otherActivities.options.yogaCycling'),
          value: 'yogaCycling',
        },
        {
          text: t('pages.onboarding.otherActivities.options.swimmingHIIT'),
          value: 'swimmingHIIT',
        },
        {
          text: t('pages.onboarding.otherActivities.options.none'),
          value: 'none',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
